export default __webpack_public_path__ + "img/notebook.07a78f65.png";